<template>
  <div id="app" v-if="webpRendered">
    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  metaInfo: {
    title: '',
    titleTemplate: '%s | Club Brugge'
  },

  mounted () {
    if (window.DeviceOrientationEvent) {
      window.addEventListener('orientationchange', function () { window.location.reload() }, false)
    }
  },

  computed: mapState({
    webpRendered: state => state.webpRendered
  })
}
</script>

<style lang="scss">
  @import './_styles/main.scss';
</style>
